import { Link } from 'react-router-dom';

import { Image, ImageWrapper, Offer } from './item.styles';

import useI18nText from '../../../../../../../hooks/useI18nText';

import type { Offer as OfferType } from '@rewardopl/types';

export default function Item({ offer }: { offer: OfferType }) {
  const { _id: offerId, name, name_i18n: nameI18n, picture } = offer;

  const nameString = useI18nText(nameI18n, name);

  return (
    <Offer as={Link} title={nameString} to={`/offers/${offerId}`}>
      <ImageWrapper>
        {picture ? (
          <Image alt={nameString} src={`/api/uploads/${picture}?w=${360 * devicePixelRatio}`} />
        ) : null}
      </ImageWrapper>
    </Offer>
  );
}
